import paginationConfig from "@/data/paginationConfig";
import SearchableListConfig from "@/entities/SearchableListConfig";

const searchableListConfig: SearchableListConfig = {
  ...paginationConfig,
  search: "",
};

export default searchableListConfig;
